import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { PriceDisplay } from '../../../../ReactComponents/PriceDisplay';
import { OrderSummaryDisplayMode } from '../../ViewModels/OrderSummaryDisplayMode.csharp';
import { OrderViewModel } from '../../ViewModels/OrderViewModel.csharp';

interface OrderDetailsPriceSummaryProps {
    order: OrderViewModel;
}

export const OrderDetailsPriceSummary = (props: OrderDetailsPriceSummaryProps) => {
    const { order } = props;
    return (
        <>
            <h3 className="OrderDetails__TotalHeading">{getTranslation(keys['orderSummary.summary'])}</h3>

            <div className="PriceSummary PriceSummary--NoMargin">
                {order.summaryDisplayMode == OrderSummaryDisplayMode.Full && (
                    <>
                        <div className="PriceSummary__Line">
                            <span className="PriceSummary__Name">{getTranslation(keys['orderSummary.sum'])}</span>
                            <span className="PriceSummary__Value" tabIndex={0}>
                                <PriceDisplay price={order.totalPlacedPrice} />
                            </span>
                        </div>
                        <div className="PriceSummary__Line">
                            <span className="PriceSummary__Name">{getTranslation(keys['orderSummary.delivery'])}</span>
                            <span className="PriceSummary__Value">
                                {order.shippingCost === 0 ? getTranslation(keys['orderSummary.freeDelivery']) : <PriceDisplay price={order.shippingCost} />}
                            </span>
                        </div>
                        {order.discountTotal > 0 && (
                            <div className="PriceSummary__Line">
                                <span className="PriceSummary__Name">{getTranslation(keys['orderSummary.discount'])}</span>
                                <span className="PriceSummary__Value PriceSummary__Value--Red">
                                    - <PriceDisplay price={order.discountTotal} />
                                </span>
                            </div>
                        )}
                        {order.refund != 0 && (
                            <div className="PriceSummary__Line">
                                <span className="PriceSummary__Name">{getTranslation(keys['orderSummary.priceAdjustment'])}</span>
                                <span className="PriceSummary__Value PriceSummary__Value--Red">
                                    <PriceDisplay price={order.refund} />
                                </span>
                            </div>
                        )}
                    </>
                )}
                <div className="PriceSummary__Line">
                    <span className="PriceSummary__Name PriceSummary__Name--UpperCase" tabIndex={0}>
                        {getTranslation(keys['orderSummary.total'])} <span>({getTranslation(keys['orderSummary.includeTax'])})</span>
                    </span>
                    <span className="PriceSummary__Value PriceSummary__Value--Bold">
                        <PriceDisplay price={order.total} showCurrency />
                    </span>
                </div>
            </div>
        </>
    );
};
